import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-100 bcl-token-list-table" }
const _hoisted_2 = { class: "text-body-2 opacity-50 text-left py-1" }
const _hoisted_3 = { class: "text-body-2 opacity-50 text-left py-1 px-3" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "text-body-2 opacity-50 text-left text-md-right py-1 px-3" }
const _hoisted_6 = { class: "text-body-2 opacity-50 text-left text-md-right py-1 px-3" }
const _hoisted_7 = { class: "text-body-2 opacity-50 text-right py-1 px-3" }
const _hoisted_8 = { class: "text-body-2 opacity-50 text-right py-1 px-3" }
const _hoisted_9 = { class: "text-body-2 opacity-50 text-right py-1 pl-3" }
const _hoisted_10 = { key: 0 }

import { computed } from "vue";

import TokenListTableRow from "./TokenListTableRow.vue";
import AppTooltip from "@/components/Common/AppTooltip.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TokenListTable',
  props: {
  pages: { type: Array, default: null },
},
  setup(__props) {

const props = __props;

const allItems = computed(() =>
  props.pages?.length ? props.pages.map((page) => page.items).flat() : []
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _cache[1] || (_cache[1] = _createElementVNode("th", null, null, -1)),
        _createElementVNode("th", _hoisted_2, [
          _createVNode(AppTooltip, null, {
            activator: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("common.rank")), 1)
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(_ctx.$t("common.rankInfo")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("th", _hoisted_3, [
          _createElementVNode("div", {
            textContent: _toDisplayString(_ctx.$t('common.tokenName'))
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("th", _hoisted_5, [
          _createVNode(AppTooltip, { end: "" }, {
            activator: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("common.collection")), 1)
            ]),
            default: _withCtx(() => [
              _cache[0] || (_cache[0] = _createTextVNode(" Category of the token. "))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("common.price")), 1),
        _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("common.marketCap")), 1),
        _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("common.contractAddress")), 1),
        _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("common.performance")), 1),
        _cache[2] || (_cache[2] = _createElementVNode("th", null, null, -1))
      ])
    ]),
    (__props.pages?.length)
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allItems.value, (token, index) => {
            return (_openBlock(), _createBlock(TokenListTableRow, {
              key: index,
              token: token
            }, null, 8, ["token"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})